﻿import React from 'react';
import { Grid, FormHelperText } from '@material-ui/core';
import { Field, FieldArray, getIn } from 'formik';

import { FileUploadContext } from '../../DropzoneFileUpload';
import FileList from '../FileList';
import FormikDropzoneFileUpload from './FormikDropzoneFileUpload';

const FormikDropzoneAttachFiles = (props) => {
  const {
    name,
    values,
    errors,
    touched,
    fileGroupId,
    gcAccountId,
    onFileUpload,
    onFileDownload,
    onFileDelete,
    maxFilesCount,
    maxFileSizeInMb,
    showDelete = true,
    showDownload = true,
    icon,
    uploadFileText,
    dataTestid,
  } = props;

  const handleDelete = (arrayHelpers, index) => {
    const fileToDelete = arrayHelpers.remove(index);
    console.log('values[name][index]', values[name][index]);
    onFileDelete(gcAccountId, fileToDelete.fileId);
  };

  const handleDownload = (index) => {
    const fileToDownload = values[name][index];
    onFileDownload(fileToDownload.fileId);
  };

  const canUpload = (file) => {
    const index = values[name].findIndex((x) => x.name === file.name);
    return index < 0;
  };

  const files = values[name].map((file, index) => {
    const fileErrors = Array.isArray(errors[name]) && getIn(touched, name) && getIn(errors, name);
    const error = fileErrors && fileErrors.length > index ? fileErrors[index] : null;

    return {
      type: file.type,
      name: file.name,
      size: file.size,
      error: error || file.error,
      uploaded: file.uploaded,
      timestamp: file.timestamp,
    };
  });

  const contextValue = {
    maxFilesCount,
    maxFileSizeInMb,
    onFileUpload,
    onFileDownload,
    fileGroupId,
    gcAccountId,
    canUpload,
    fileCount: values[name].length,
  };

  const showNoFilesError = () => {
    return errors && errors[name] && !files.length > 0;
  };

  return (
    <FileUploadContext.Provider value={contextValue}>
      <FieldArray
        name={name}
        render={(arrayHelpers) => (
          <React.Fragment>
            <Grid item xs={12}>
              <Field
                name={name}
                component={FormikDropzoneFileUpload}
                variant="outlined"
                color="secondary"
                dataTestid={dataTestid ?? 'uia-fileUpload'}
                disabled={props.disabled}
                icon={icon}
                uploadFileText={uploadFileText}
              />
              {showNoFilesError() && (
                <FormHelperText className="Mui-error">{errors[name]}</FormHelperText>
              )}
              {values[name] && values[name].length > 0 && (
                <FileList
                  files={files}
                  onDelete={(index) => handleDelete(arrayHelpers, index)}
                  onDownload={(index) => handleDownload(index)}
                  showDelete={showDelete}
                  showDownload={showDownload}
                />
              )}
            </Grid>
          </React.Fragment>
        )}
      />
    </FileUploadContext.Provider>
  );
};

export default FormikDropzoneAttachFiles;
